import styled from "styled-components";
import { Button, colors, typography } from "@streeteasy/design-system";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";

const {
  BRAND_DARK,
  GRAY_LIGHTEST,
  SUCCESS,
  TEXT_PRIMARY,
  TEXT_SECONDARY
} = colors;
const { Caps } = typography;

export const CheckIcon = styled(FontAwesomeIcon).attrs({
  iconClass: "check"
})`
  color: ${SUCCESS};
  padding: 0 6px 0 8px;
  vertical-align: baseline;
`;

export const Container = styled.div`
  background-color: ${GRAY_LIGHTEST};
  line-height: 15px;
  overflow: hidden;
  padding: 16px;
  position: relative;
`;

export const EditButton = styled(Button)`
  background: none;
  border: none;
  color: ${BRAND_DARK};
  float: right;
  height: 100%;
  min-width: auto;
  padding: 0;
  text-transform: uppercase;
  &:hover,
  &:active {
    background-color: transparent;
  }
`;

export const EditIcon = styled(FontAwesomeIcon).attrs({
  iconClass: "edit"
})`
  color: ${BRAND_DARK};
  padding: 0 4px 0 0;
  vertical-align: bottom;
`;

export const Header = styled(Caps)`
  color: ${TEXT_SECONDARY};
  display: inline-block;
`;

export const Note = styled.span`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  color: ${TEXT_PRIMARY};
  display: -webkit-box;
  line-height: 22px;
  overflow: hidden;
  overflow-wrap: break-word;
  padding-top: 8px;
`;

export const SavedNotification = styled.span`
  color: ${SUCCESS};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
`;
